<template>
    <div class="application">

        <div class="title gradient blue">

            <div class="logo">

                <img :src="require(`@/assets/images/application/icon/${name}.png`)" :alt="name" />

            </div>

        </div>

        <div class="description">

            <a :href="url" target="_blank">
                <h3>{{ title }}</h3>
            </a>

            <p>{{ $t(`${description}`) }}</p>

        </div>

        <div v-if="doc" class="documentation">
            <button class="btn" v-on:click="openDocumentation()">
                {{ $t('DOCUMENTATION') }}
            </button>
        </div>

    </div>
</template>

<style lang="scss" scoped>
.application
{
    position: relative;
    display: flex;
    flex-flow: column;

    margin: 20px;

    width: 300px;
    flex-shrink: 0;

    border-radius: 8px;
    box-sizing: border-box;

    box-shadow: 0px 0px 60px 0px rgba(0, 0, 0, 0.1);
    transition: all 0.5s ease;

    background: #ffffff;

    .title
    {
        display: flex;

        align-items: center;
        justify-content: space-around;

        padding: 20px;
        border-radius: 8px 8px 0 0;
    }

    .logo
    {
        display: flex;

        margin: 0;
        padding: 12px;

        width: 60px;
        height: 60px;

        border-radius: 8px;

        background: #ffffff;

        img
        {
            align-self: center;
            margin: auto;

            max-width: 100%;
            max-height: 100%;
        }
    }

    .description
    {
        padding: 20px;
        text-align: left;

        flex-grow: 1;

        a {
            display: block;
            text-align: center;

            text-decoration: none;
            cursor: pointer;

            &:hover, &:active, &:visited {
                text-decoration: none;
            }

            h3
            {
                margin: 0 0 22px 0;
                color: #271840;
            }
        }

        p
        {
            font-size: 14px;
        }
    }

    .documentation
    {
        padding: 10px;
        text-align: center;

        a
        {
            text-decoration: none;
            cursor: pointer;

            &:hover
            {
                box-shadow: 0px 0px 60px 0px rgba(0, 0, 0, 0.2);
            }
        }
    }
}
</style>

<script>
export default {
    name: 'application',
    props: {
        url: String,
        doc: Boolean,
        docAlternative: String,
        name: String,
        title: String,
        description: String,
    },
    methods: {
        openDocumentation: function()
        {
            if (this.doc === true && (typeof this.docAlternative === 'undefined' || this.docAlternative === ''))
            {
                window.open(`/documentation/${this.name}`, '_blank');
            }
            else
            {
                window.open(`${this.docAlternative}`, '_blank');
            }
        },
    },
};
</script>
